// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';


// -------------------------------------
// Hooks
// -------------------------------------

// Stick the header when scrolling past the top
$(window).scroll(function() {
    var rollOverElement = $('.page-section--rollover');
    if(rollOverElement.length) {
        var rollOverElementPos = rollOverElement[0].getBoundingClientRect();
    }

    if(! $('body').hasClass('template-product')) {
        if ($(window).scrollTop() > 0) {
            $('.header').addClass('is-sticky');
            $('.announcement-bar').addClass('is-sticky');
            $('body').addClass('is-sticky');
            $('.rollover').addClass('is-sticky');
    
            if(rollOverElement.length) {
                // checking whether fully visible
                if(rollOverElementPos.bottom <= window.innerHeight) {
                    $('.page-section--rollover').addClass('rollover');
                }
            }
        } else {
            $('.page-section--rollover').removeClass('rollover');
            $('.header').removeClass('is-sticky');
            $('body').removeClass('is-sticky');
            $('.announcement-bar').removeClass('is-sticky');
            $('.rollover').removeClass('is-sticky');
        }
    }
});
